import { vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-nav-id"]
const _hoisted_2 = ["value", "aria-label", "disabled"]
const _hoisted_3 = { class: "selectable-participant__content" }
const _hoisted_4 = { class: "selectable-participant__content-name" }
const _hoisted_5 = {
  key: 0,
  class: "selectable-participant__content-subname"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_IconCheck = _resolveComponent("IconCheck")

  return (_openBlock(), _createElementBlock("label", {
    class: "selectable-participant",
    "data-nav-id": $options.participantNavigationId
  }, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.modelProxy) = $event)),
      value: $options.value,
      "aria-label": $options.participantAriaLabel,
      disabled: $setup.isLocked,
      type: "checkbox",
      class: "selectable-participant__checkbox",
      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers((...args) => ($options.handleEnter && $options.handleEnter(...args)), ["stop","prevent"]), ["enter"]))
    }, null, 40, _hoisted_2), [
      [_vModelCheckbox, $options.modelProxy]
    ]),
    _createVNode(_component_AvatarWrapper, {
      id: $options.actorId,
      token: $props.participant.roomToken ?? 'new',
      name: $options.computedName,
      source: $options.actorType,
      "disable-menu": "",
      "disable-tooltip": "",
      "preloaded-user-status": $options.preloadedUserStatus,
      "show-user-status": $props.showUserStatus
    }, null, 8, ["id", "token", "name", "source", "preloaded-user-status", "show-user-status"]),
    _createElementVNode("span", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString($options.computedName), 1),
      ($options.participantStatus)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($options.participantStatus), 1))
        : _createCommentVNode("", true)
    ]),
    ($setup.isBulkSelection)
      ? (_openBlock(), _createBlock(_component_IconCheck, {
          key: 0,
          class: "selectable-participant__check-icon",
          size: 20
        }))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}